/* Just Tattoos — hero slideshow (progressive enhancement).
   Pairs a [data-hero] section with the style-chips row ([data-hero-tab]).
   Without this file the first slide and its copy still render. */
(function () {
  'use strict';

  if (window.__jtHero) return;
  window.__jtHero = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function tabsFor(hero) {
    var anchor = hero.getAttribute('data-hero-anchor') || 'hero';
    var groups = document.querySelectorAll('[data-hero-tabs]');
    var list = [];
    for (var i = 0; i < groups.length; i++) {
      var target = groups[i].getAttribute('data-hero-tabs');
      if (target === anchor || !target) {
        var found = groups[i].querySelectorAll('[data-hero-tab]');
        for (var j = 0; j < found.length; j++) list.push(found[j]);
      }
    }
    if (!list.length) {
      var any = document.querySelectorAll('[data-hero-tab]');
      for (var k = 0; k < any.length; k++) list.push(any[k]);
    }
    return list;
  }

  function initHero(hero) {
    var slides = hero.querySelectorAll('[data-hero-slide]');
    if (slides.length < 2) return;
    var tabs = tabsFor(hero);
    var autoplay = hero.getAttribute('data-autoplay') !== 'false' && !reduce.matches;
    var interval = parseInt(hero.getAttribute('data-interval'), 10) || 5500;
    var current = 0;
    var timer = null;
    var paused = false;

    function clearProgress() {
      for (var i = 0; i < tabs.length; i++) {
        var span = tabs[i].querySelector('.hero-tab-progress');
        if (span && span.parentNode) span.parentNode.removeChild(span);
      }
    }

    function paint(index) {
      current = (index + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        var active = i === current;
        slides[i].classList.toggle('is-active', active);
        slides[i].setAttribute('aria-hidden', active ? 'false' : 'true');
      }
      clearProgress();
      for (var j = 0; j < tabs.length; j++) {
        var isActive = parseInt(tabs[j].getAttribute('data-slide-index'), 10) === current;
        tabs[j].classList.toggle('pill--accent', isActive);
        tabs[j].setAttribute('aria-selected', isActive ? 'true' : 'false');
        tabs[j].setAttribute('tabindex', isActive ? '0' : '-1');
        if (isActive && autoplay) {
          var span = document.createElement('span');
          span.className = 'hero-tab-progress';
          span.setAttribute('aria-hidden', 'true');
          span.style.animationDuration = interval + 'ms';
          if (paused) span.style.animationPlayState = 'paused';
          tabs[j].appendChild(span);
        }
      }
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    function schedule() {
      stop();
      if (!autoplay) return;
      timer = window.setInterval(function () {
        if (paused || document.hidden) return;
        paint(current + 1);
      }, interval);
    }

    function goTo(index) {
      paint(index);
      schedule();
    }

    for (var t = 0; t < tabs.length; t++) {
      (function (tab) {
        tab.addEventListener('click', function (event) {
          var index = parseInt(tab.getAttribute('data-slide-index'), 10);
          if (isNaN(index)) return;
          if (tab.tagName !== 'A') event.preventDefault();
          goTo(index);
        });
        tab.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(current + (event.key === 'ArrowRight' ? 1 : -1));
            if (tabs[current] && tabs[current].focus) tabs[current].focus();
          }
        });
      })(tabs[t]);
    }

    function setPaused(state) {
      paused = state;
      var span = document.querySelector('[data-hero-tabs] .hero-tab-progress');
      if (span) span.style.animationPlayState = state ? 'paused' : 'running';
    }

    hero.addEventListener('mouseenter', function () { setPaused(true); });
    hero.addEventListener('mouseleave', function () { setPaused(false); });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && autoplay) schedule();
    });

    if (tabs.length) {
      var group = tabs[0].closest('[data-hero-tabs]');
      if (group) {
        group.addEventListener('mouseenter', function () { setPaused(true); });
        group.addEventListener('mouseleave', function () { setPaused(false); });
      }
    }

    paint(0);
    schedule();
  }

  function init() {
    var heroes = document.querySelectorAll('[data-hero]');
    for (var i = 0; i < heroes.length; i++) initHero(heroes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
